import * as gfunctions from '../../../js/generalFunctions';

CCL.addAnotherAccessDetails = {
  autoload: [
    ['addAnotherAccessDetails', $('#organizerAccessModal').length > 0],
    ['bookingsValidation', $('#organizerAccessModal').length > 0],
    ['saveOrganizerDetails', $('#organizerAccessModal').length > 0],
    ['modalEvents', $('#organizerAccessModal').length > 0]
  ],

  tempArr: [],
  ajaxResponse: [],
  isorganizer: false,
  tryCount: 0,
  retryLimit: 3,

  guidGenerator() {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  },
  addAnotherAccessDetails() {
    $('body').on('click', '.organizer-access-modal-open-button', (event) => {
      // gfunctions.hideModal('bookingBuddyModal'); keeping as opeen as ccl requested.
      gfunctions.showModal('organizerAccessModal');
      this.isorganizer = false;
      if (event.currentTarget.dataset.isorganizer && event.currentTarget.dataset.isorganizer === 'true') {
        this.isorganizer = true;
      }
      this.toOriginalState();
    });

    $('body').on('click', '#organizerAccessModal .close', (event) => {
      if (this.ajaxResponse.length) {
        if (this.ajaxResponse.some(x => x.success === true || x.success === 'true')) {
          // everything got added successfully then set the cookie
          if (this.ajaxResponse.length) {
            this.setActiveSailing(this.ajaxResponse[0].bookingNumber);
          }
        } else {
          gfunctions.hideModal('organizerAccessModal');
        }
      } else {
        gfunctions.hideModal('organizerAccessModal');
      }
      setTimeout(() => {
        $('body').addClass('modal-open');
      }, 500);
    });

    $('body').on('click', '.add-another', (event) => {
      //  $('.save-organizer-details').prop('disabled', true);

      event.preventDefault();
      const id = this.guidGenerator();
      const getDivCount = $('#addedAccess-1').length + 1;
      const hideClass = this.isorganizer ? 'hide-save-to-profile' : '';
      const accessform = `
        <div class="access-form newly-added" id='addedAccess-${id}'>
            <div class="input-wrap">
                <div class="user-input-wrp size-md booking-id">
                  <label></label>
                  <input type="text" autocomplete="off" id="bookingId-${id}" class="inputText booking-id-input" aria-label="Please enter booking id" required />
                  <span class="floating-label">Booking #</span>
                </div>
                <div class="input-errors">
                  <span role="alert" aria-live="assertive" aria-label="Booking number is invalid">Booking number is invalid</span>
                </div>
            </div>
            <div class="input-wrap">
                <div class="user-input-wrp size-lg">
                  <label></label>
                  <input type="text" autocomplete="off" id="guestName-${id}" class="inputText guestname-input" aria-label="Please Enter last name of guest" required />
                  <span class="floating-label">Last Name of Guest</span>
                </div>
              <div class="input-errors">
                <span role="alert" aria-live="assertive">Last Name is invalid</span>
              </div>  
            </div>
            <div class="input-wrap save-to-profile-wrap">
            This booking will be saved to your profile.
                <div class="custom-control custom-checkbox user-input-wrp save-to-profile d-none">
                  <input type="checkbox" checked class="custom-control-input" id="save-${id}">
                  <label class="custom-control-label" for="save-${id}">Save this to my profile</label>
                </div>
            </div>    
            <div class="error-text" role="alert" aria-live="assertive">
              This booking number and last name combination could not be found.
            </div>
            <div class="user-input-wrp booking-added" style="display:none">
              <img src="/_ui/responsive/ccl/assets/icons/check mark.svg" alt="check"/> <span>Booking Added</span>
            </div>
        </div>
        `;

      if ($('.access-form').length < 7) {
        $('.add-another').show();
        $('.animation-from').append(accessform);
      }
      let accessformCount = $('.access-form').length;
      $('.add-another').attr('aria-label', `${accessformCount} of 7 maximum requests added`);
      if ($('.access-form').length === 7) {
        accessformCount = 7;
        setTimeout(() => {
          $('.add-another').hide();
        }, 1000);
      }
    });
  },

  toOriginalState() {
    $('.save-organizer-details').prop('disabled', true);
    if ($('.modal:visible').length) {
      setTimeout(() => {
        $('body').addClass('modal-open');
      }, 500);
    }
    // Remove newly added and blank first row values
    $('.newly-added').remove();
    $('#bookingId-input1').val('');
    $('#guestName-input1').val('');
    $('#addedAccess-1 .booking-added').hide();
    $('#addedAccess-1 .save-to-profile-wrap').show();
    $('#addedAccess-1 .save-to-profile-input')[0].checked = true;
    $('#addedAccess-1 .error-text').hide();
    $('#addedAccess-1').removeClass('div-disable');
    if ($('.access-form').length < 7) {
      $('.add-another').show();
    }
    // if (this.isorganizer) {
    //   $('#organizerAccessModal .save-to-profile-wrap').hide();
    // }
  },


  bookingsValidation() {
    $('.c-organizer-access-modal').on('keyup', '.access-form .booking-id-input', (e) => {
      $(e.currentTarget).removeClass('not-valid');
      $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      $(e.currentTarget.offsetParent.parentElement.parentElement).find('.error-text').hide();
      $(e.currentTarget).attr('maxlength', '6');
      const regex = /^[0-9a-zA-Z]+$/;
      if ((e.currentTarget.value.length < 6 && e.currentTarget.value.length > 0 && $(e.currentTarget).hasClass('booking-id-input')) || ((!regex.test(e.currentTarget.value)) && e.currentTarget.value.length > 0)) {
        $(e.currentTarget).addClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).attr('aria-label', `Booking Number ${e.currentTarget.value} is invalid`);
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).show();
      } else {
        $(e.currentTarget).removeClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      }
      this.validateInputs();
    });

    $('.c-organizer-access-modal').on('keyup', '.access-form .guestname-input', (e) => {
      const regex = /^[a-zA-Z\-' ]{0,32}$/;
      $(e.currentTarget.offsetParent.parentElement.parentElement).find('.error-text').hide();
      if (regex.test(e.currentTarget.value)) {
        $(e.currentTarget).removeClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).hide();
      } else {
        $(e.currentTarget).addClass('not-valid');
        $(e.currentTarget.parentElement.nextElementSibling.firstElementChild).show();
      }
      this.validateInputs();
    });
  },


  validateInputs() {
    let isError = true;
    $('.access-form').each((index, element) => {
      const bookingNumberElement = element.children[0].children[0].children[1];
      const lastNameElement = element.children[1].children[0].children[1];

      // check if atleast one line is correct
      // if ((bookingNumberElement.value && lastNameElement.value) && (!$(bookingNumberElement).hasClass('not-valid') && !$(lastNameElement).hasClass('not-valid'))) {
      //   isError = false;
      // }

      // check if any line has error
      // if ((bookingNumberElement.value === '' || lastNameElement.value === '') || ($(bookingNumberElement).hasClass('not-valid') || $(lastNameElement).hasClass('not-valid'))) {
      //   isError = true;
      // }
      if ((bookingNumberElement.value !== '' && lastNameElement.value !== '') && (!$(bookingNumberElement).hasClass('not-valid') && !$(lastNameElement).hasClass('not-valid'))) {
        isError = false;
      }
    });

    if (isError) {
      $('.save-organizer-details').prop('disabled', true);
    } else {
      $('.save-organizer-details').prop('disabled', false);
    }
  },
  saveOrganizerDetails() {
    $('.save-organizer-details').click(() => {
      const bookings = [];
      $('.access-form').each((index, element) => {
        const bookingNumber = element.children[0].children[0].children[1].value.toUpperCase();
        const lastName = element.children[1].children[0].children[1].value.toUpperCase();
        const saveToProfile = this.isorganizer ? false : element.children[2].children[0].children[0].checked;
        if (bookingNumber && lastName) {
          const bookingObj = { bookingNumber, lastName, saveToProfile };
          bookings.push(bookingObj);
        }
        // remove all classes starting with 'row-'
        $(element).attr('class', (i, c) => {
          return c.replace(/(^|\s)row-\S+/g, '');
        });
        // add dynamic classes to div to show error msgs on response
        if ($(element.children[0].children[0]).hasClass('booking-id')) {
          $(element).addClass(`row-${bookingNumber}_${lastName}`);
          $(element).removeClass('div-disable');
        }
      });
      this.orgAccessModalResponse(bookings);
    });
  },
  orgAccessModalResponse(bookings) {
    gfunctions.showLoader();

    let ajaxUrl = '';
    let ajaxType = '';
    if (window.location.hostname === 'localhost' && window.location.port === '6565') {
      ajaxUrl = '/json-data/organizer-access-response.json';
      ajaxType = 'GET';
    } else {
      ajaxUrl = '/booked/api/v1.0/bookings';
      ajaxType = 'POST';
    }
    const token = $('#csrfSessionToken').data('csrf');
    $.ajax({
      type: ajaxType,
      url: ajaxUrl,
      xhrFields: { withCredentials: true },
      crossDomain: true,
      contentType: 'application/json',
      data: JSON.stringify({ bookings }),
      headers: {
        CSRFToken: token
      }
    }).done((response) => {
      gfunctions.hideLoader();
      $('.booking-added').hide();
      $('.error-text').hide();

      if (response.code && response.code === 'RequestsFailed') {
        this.showAddedBooking(response.innerError.data.responses);
      } else {
        this.showAddedBooking(response.responses);
      }
    }).fail(({ responseJSON }) => {
      // When we are getting 409 but getting the response in return
      gfunctions.hideLoader();
      $('.booking-added').hide();
      $('.error-text').hide();
      if (responseJSON.code && responseJSON.code === 'RequestsFailed') {
        this.showAddedBooking(responseJSON.innerError.data.responses);
      } else {
        this.showAddedBooking(responseJSON.responses);
      }
      console.log('Something went wrong while update organizer access');
    });
  },

  showAddedBooking(responses) {
    if (responses.length) {
      this.ajaxResponse = responses;
    }
    const errCount = [];
    let focusOn = false;
    $.each(responses, (index, cValue) => {
      const curentClass = `.row-${cValue.bookingNumber}_${cValue.lastName}`;
      if (!cValue.success || cValue.success === 'false') {
        $(curentClass).find('.error-text').html('This booking number and last name combination could not be found');
        errCount.push(cValue.success);
        if (cValue.details.length) {
          if (cValue.details[0].code.toString() === '5541') {
            const msg = cValue.details[0].message ? cValue.details[0].message : 'This booking number and last name combination could not be found';
            $(curentClass).find('.error-text').html(msg);
          }
        }
        $(curentClass).find('.error-text').show();
        if (!focusOn) {
          $(curentClass).find('.booking-id-input').addClass('ada-element-focus');
          $(curentClass).find('.booking-id-input').focus();
          focusOn = true;
        }
      } else {
        $(curentClass).addClass('div-disable');
        $(curentClass).find('.booking-added').attr('aria-label', `booking ${cValue.bookingNumber} added to profile`);
        const msg = cValue.addedTravelWith ? 'Booking added and set as travel companion' : 'Booking added';
        $(curentClass).find('.booking-added span').text(msg);
        $(curentClass).find('.booking-added').attr('role', 'alert').attr('aria-live', 'assertive');
        $(curentClass).find('.booking-added').css('display', 'inline-block');
        $(curentClass).find('.save-to-profile-wrap').hide();
      }
    });

    if (responses.every(x => x.success === true || x.success === 'true')) {
      if (responses.every(x => x.addedTravelWith === true || x.addedTravelWith === 'true')) {
        $('#organizerAccessModal .booking-success-alert').find('.success-msg').hide();
        $('#organizerAccessModal .booking-success-alert').find('.success-companion-msg').show();
      } else {
        $('#organizerAccessModal .booking-success-alert').find('.success-msg').show();
        $('#organizerAccessModal .booking-success-alert').find('.success-companion-msg').hide();
      }
      // everything got added successfully then set the cookie
      if (responses.length) {
        this.setActiveSailing(responses[0].bookingNumber);
      }
    }
  },

  /* eslint-disable */
  setActiveSailing(id) {
    gfunctions.showLoader();
    $.ajax({
      type: 'GET',
      url: `/shop/gifting/refresh-sailings/${id}`
    }).done((response) => {
      gfunctions.hideLoader();
      gfunctions.setSailingContextCookie(response.activeSailingId);
      $('#organizerAccessModal .booking-success-alert').removeClass('d-none');
      setTimeout(() => {
        $('#organizerAccessModal').modal('hide');
        window.location.href = '/booked/home';
      }, 4000);
    }).fail((xhr) => {
      gfunctions.hideLoader();
      if (xhr.status === 404) {
        this.tryCount++;
        if (this.tryCount <= this.retryLimit) {
          // if there was an error, wait 4 seconds and re-run the function
          setTimeout(() => {
            console.log(`Retrying call again. Try - ${this.tryCount}`);
            this.setActiveSailing(id);
          }, 3000)
        }
      }
      console.log('refresh sailing ajax failed');
    });
  },
  /* eslint-enable */
  modalEvents() {
    const modalEl = $('#organizerAccessModal');

    modalEl.find('button.close').on('keydown', (event) => {
      if ((event.keyCode === 9) && (event.shiftKey)) {
        event.preventDefault();
        const lastFocusable = gfunctions.getFocusableElements(modalEl, 'last');
        lastFocusable.focus();
      }
    });
    modalEl.find('.add-another').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        if (modalEl.find('.save-organizer-details:disabled').length > 0) {
          const firstFocusable = gfunctions.getFocusableElements(modalEl);
          firstFocusable.focus();
        } else {
          modalEl.find('.save-organizer-details').focus();
        }
      }
    });
    modalEl.find('.save-organizer-details').on('keydown', (event) => {
      if ((event.keyCode === 9) && !(event.shiftKey)) {
        event.preventDefault();
        const firstFocusable = gfunctions.getFocusableElements(modalEl);
        firstFocusable.focus();
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/components/c-organizer-access-modal/organizer-access-modal.js